import aboutText from "./about";
import Email from "../email";
import { Link } from "react-router";
import Logo from "../navbar/logo";
import Notices from "./notices";
import Phone from "../phone";
import PropTypes from "prop-types";
import React from "react";
import Social from "../social/social";
import { showFairHousingNotice, validate2AgentTeam } from "../../shared/util";
import Phones from "../../contact/phones";
import TeamPhone from "../../shared/team-phone";
import Disclaimer from "./disclaimer";
import RebnyFooter from "./rebny-footer";

const Footer = ({ navItems, entity, listing }) => {
  const footerLinks = [
    {
      label: "Fair Housing Statement",
      link: "https://www.sothebysrealty.com/eng/full-disclaimer",
      external: true,
    },
    {
      label: "Privacy Policy",
      link: "https://www.sothebysrealty.com/eng/privacy-policy",
      external: true,
    },
    {
      label: "Accessibility Statement",
      link: "https://www.sothebysrealty.com/eng/ada",
      external: true,
    },
    {
      label: "Terms of Use",
      link: "https://www.sothebysrealty.com/eng/terms",
      external: true,
    },
    {
      label: "DMCA Notice",
      link: "https://www.sothebysrealty.com/eng/dmca-notice",
      external: true,
    },
    {
      label: "Do Not Sell My Info",
      link: "https://submit-irm.trustarc.com/services/validation/77ff5121-d832-49f1-8938-a608c379733f",
      external: true,
    },
    {
      label: "Contact Us",
      link: "/contact",
    },
    {
      label: "Standardized Operating Procedures for NY Brokerages",
      link: "/pdf/Standardized_Operating_Procedure.pdf",
      external: true,
    },
  ];

  if (showFairHousingNotice(entity)) {
    footerLinks.splice(1, 0, {
      label: "Fair Housing Notice",
      link: "https://www.dos.ny.gov/licensing/docs/FairHousingNotice_new.pdf",
      external: true,
    });
  }

  const isListingPage = () => {
    console.log(listing);
    const url = window.location.href;
    //checking for the detail page
    if (url.includes("/nyc/sales/")) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="footer">
      <div className="container web-container">
        <div className="row">
          <div className="col-xs-16 col-sm-6">
            <h2>About</h2>
            <p className="column-body">{aboutText(entity)}</p>
          </div>
          <div className="col-xs-16 col-sm-5 navigate">
            <h2>Navigate</h2>
            <ul className="column-body">
              {navItems.map((x) => (
                <li key={x.label}>
                  <Link
                    to={x.link}
                    target={x.external ? "_blank" : ""}
                    dangerouslySetInnerHTML={{ __html: x.label }}
                  />
                </li>
              ))}
            </ul>
          </div>
          <div className="col-xs-16 col-sm-5">
            <h2>Contact</h2>
            <div className="column-body">
              <div>{entity.displayName}</div>
              <div>{entity.title}</div>
              <div>
                {entity.office.address1} {entity.office.address2}
              </div>
              <div>
                {entity.office.town}, {entity.office.state} {entity.office.zip}
              </div>
              {entity && validate2AgentTeam(entity) ? (
                <TeamPhone
                  classes="line-item"
                  entity={entity}
                  prefix="Tel"
                  separator={false}
                />
              ) : (
                <Phones entity={entity} />
              )}
              <div>
                <Phone number={entity.fax || entity.office.fax} prefix="F" />
              </div>
              <div>
                <Email email={entity.emailAddress} />
              </div>
              <div>{entity.license}</div>
              <div>
                <Social socials={entity.socials} />
              </div>
            </div>
          </div>
        </div>
        <div className="separator"></div>
        <div className="footer-bottom">
          <div className="row">
            <Logo
              entity={entity}
              classes="col-xs-16 col-sm-6"
              showBrandLogo={true}
            />
            <div className="col-xs-16 col-sm-10">
              <ul className="footer-links">
                {footerLinks.map((l) => (
                  <li key={l.label}>
                    <a href={l.link} target={l.external ? "_blank" : ""}>
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
              <Notices entity={entity} />
            </div>
          </div>
          <div className="disclaimer">
            {/*  <p>
              Sotheby’s International Realty Inc. fully supports the principles of
              the Fair Housing Act and the Equal Opportunity Act. Each Office is Independently
              Owned and Operated. Sotheby’s International Realty, the Sotheby’s International
              Realty logo, "For the Ongoing Collection of Life" and RESIDE are registered (or
              unregistered) service marks owned or licensed to Sotheby’s International Realty
              Affiliates LLC.
            </p> */}
            <p>
              <Disclaimer />
            </p>
          </div>
          {listing !== undefined &&
          listing.source === "REBNY" &&
          isListingPage() ? (
            <div>
              <RebnyFooter theme={entity.siteOptions.theme} />
            </div>
          ) : (
            ""
          )}

          {/* <div className="column-body">
            <p>Copyright 2004-{new Date().getFullYear()} Sotheby's International Realty, Inc. All Rights Reserved.</p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  entity: PropTypes.object.isRequired,
  navItems: PropTypes.array.isRequired,
  listing: PropTypes.object,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/shared/footer/footer.js